// "Report a bug. Help the site grow": the same bubble the other Slam Bench pages have, for this page.
// Posts to /api/feedback of the site this page is served under (slambench.com), the same private store.
const START = Date.now();

async function ready(): Promise<boolean> {
  try {
    const r = await fetch("/api/feedback");
    return r.ok && ((await r.json()) as { ready?: boolean }).ready === true;
  } catch {
    return false;
  }
}

export async function mountFeedbackBubble() {
  if (!(await ready())) return;
  const root = document.createElement("div");
  root.className = "fdbk-root";
  root.innerHTML = `
    <div class="fdbk-panel" role="dialog" aria-label="Report a bug" hidden>
      <button class="fdbk-close" aria-label="Close">×</button>
      <p class="fdbk-q">What went wrong?</p>
      <textarea class="fdbk-input" rows="4" maxlength="500" placeholder="Bug, missing thing, idea: anything"></textarea>
      <input class="fdbk-trap" name="website" tabindex="-1" autocomplete="off" aria-hidden="true">
      <p class="fdbk-msg" hidden></p>
      <div class="fdbk-row"><a class="fdbk-privacy" href="/privacy">Privacy</a><button class="fdbk-send" disabled>Send</button></div>
    </div>
    <button class="fdbk-orb-row" aria-label="Report a bug and help the site grow" title="Report a bug">
      <img class="fdbk-emb" src="/buildhelper.webp" alt="" draggable="false">
      <span>Report a bug. Help the site grow</span>
    </button>`;
  document.body.appendChild(root);
  const q = <T extends HTMLElement>(s: string) => root.querySelector(s) as T;
  const panel = q<HTMLDivElement>(".fdbk-panel");
  const input = q<HTMLTextAreaElement>(".fdbk-input");
  const send = q<HTMLButtonElement>(".fdbk-send");
  const msg = q<HTMLParagraphElement>(".fdbk-msg");
  const toggle = () => {
    panel.hidden = !panel.hidden;
    if (!panel.hidden) input.focus();
  };
  q(".fdbk-orb-row").addEventListener("click", toggle);
  q(".fdbk-close").addEventListener("click", toggle);
  input.addEventListener("input", () => (send.disabled = input.value.trim().length < 10));
  send.addEventListener("click", async () => {
    send.disabled = true;
    send.textContent = "Sending…";
    try {
      const r = await fetch("/api/feedback", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          message: input.value.trim(),
          site: "slambench",
          page: "ee2",
          website: q<HTMLInputElement>(".fdbk-trap").value,
          t: Date.now() - START,
        }),
      });
      const d = (await r.json().catch(() => ({}))) as { ok?: boolean; reason?: string };
      msg.hidden = false;
      msg.textContent = d.ok ? "Thank you. It reached us." : d.reason || "Could not send it. Please try again later.";
      if (d.ok) input.value = "";
    } catch {
      msg.hidden = false;
      msg.textContent = "Could not send it. Please try again later.";
    }
    send.textContent = "Send";
    send.disabled = input.value.trim().length < 10;
  });
}
